import React from 'react'
import cn from 'classnames'

import Tab from './Tab'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const styles = require('./Tabs.styles.scss')

interface Props {
  activeTabIndex: number
  onSelect: (tabIndex: number) => void
  contentClass?: string
  children: React.ReactElement<React.ComponentProps<typeof Tab>>[]
}

export default function Tabs(props: Props) {
  return (
    <div className={styles.root}>
      <div className="tabs-row">
        {React.Children.map(
          props.children,
          (
            child: React.ReactElement<React.ComponentProps<typeof Tab>>,
            index
          ) => (
            <button
              className={cn({ active: props.activeTabIndex === index })}
              onClick={() => {
                props.onSelect(index)
              }}
            >
              {child.props.title}
            </button>
          )
        )}
      </div>
      <div className={props.contentClass}>
        {props.children[props.activeTabIndex]}
      </div>
    </div>
  )
}

Tabs.Tab = Tab
